import { ReactNode } from "react"

export const SettingSection = ({ title, description, children }: { title: string, description?: string, children: ReactNode}) => {
  return (
    <section aria-labelledby={`${title}-heading`}>
      <div className="bg2 shadow sm:rounded">
        <div className="py-6 px-4 sm:p-6">
          <div className='mb2'>
            <h4
              id={`${title}-heading`}
              className="leading-6 font-medium"
            >
              {title || "Payment details"}
            </h4>
            {!!description && <p className="mt-1 text-sm text-gray-500">
              {description}
            </p>}
          </div>
          {children}
        </div>
      </div>
    </section>
  )
}